<template>
  <router-link class="view-controls__link" v-bind:to="to" active-class="view-controls__link--active" v-bind:class="(scene < current)? 'view-controls__link--active' : ''">
    <span class="view-controls__link-label"><slot></slot></span>
    <div class="view-controls__link-icon" v-html="icon"></div>
  </router-link>
</template>

<script>
  export default {
    props: {
      to: Object,
      scene: Number,
      current: Number
    },
    data: function () {
      // disable all other loaders (https://webpack.github.io/docs/loaders.html#loader-order)
      return { icon: require('!!raw!../assets/svg/view-controller__shield.svg') }
    }
  }
</script>



// WEBPACK FOOTER //
// ViewLink.vue?40cdf592